module.exports = __webpack_public_path__ + "static/img/4.9e4664d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/4.png
// module id = zSWF
// module chunks = 0